import $ from 'jquery'
import 'bootstrap-select'
import 'bootstrap-select/dist/css/bootstrap-select.css'

$(function() {
  $('[data-bootstrap-select]').selectpicker()
})
